export default {
  autoRenewalOptIn:
    "I understand and agree that my subscription(s) will be charged on an automatic renewal basis, until I cancel or revoke."
};
